import type { SignedDocument } from "store/articleStore";

export const searchHaystack = (doc: SignedDocument): string =>
    [doc.articleName, doc.templateName, doc.filename, doc.titleName].filter(Boolean).join(" ").toLowerCase();

/**
 * Maps a document to its filter category.
 * Avenant always wins over relatedResource type — by design avenants are
 * labelled "avenant" regardless of whether they belong to a framework contract
 * or a plain article.
 */
export const getCategory = (doc: SignedDocument): "agreement" | "avenant" | "framework_contract" => {
    if (doc.type === "avenant") return "avenant";
    if (doc.relatedResource === "frameworkContract") return "framework_contract";
    return "agreement";
};

export const typeLabel = (doc: SignedDocument, t: (key: string) => string): string => {
    const isFramework = doc.relatedResource === "frameworkContract";
    if (isFramework) {
        return doc.type === "avenant"
            ? t("BPTitle.DocumentTypeFrameworkAddendum")
            : t("BPTitle.DocumentTypeFrameworkContract");
    }
    return doc.type === "avenant" ? t("BPTitle.DocumentTypeAvenant") : t("BPTitle.DocumentTypeAgreement");
};
